import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

import ProgramDocumentCard from "./program-documents/ProgramDocumentCard";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as actions from "src/redux/slices/programSlice";
import Button from "../app/Button";
import analytics from "src/helpers/analytics";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";
import supportPrograms from "src/data/app/programs";

interface UploadDocumentsProps {
  title: string;
  description: string;
  documentType: string;
  documents: any[];
  onBack: () => void;
  onNext: () => void;
  support_program_key?: string;
}

const UploadDocuments: React.FC<UploadDocumentsProps> = ({
  title,
  description,
  documentType,
  documents,
  onBack,
  onNext,
  support_program_key,
}) => {
  const dispatch = useAppDispatch();
  const { programRecords } = useAppSelector((state) => state.program);
  const { patient, updateProfile } = useAppSelector((state) => state.auth);
  const [enableContinue, setEnableContinue] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);

  useEffect(() => {
    // Event: UPLOAD_DOCUMENTS_VIEWED
    analytics.pageView(SCREEN_NAMES.UPLOAD_DOCUMENTS_SCREEN);

    // Get Program Records
    getProgramRecords();
  }, []);

  //   useEffect(() => {
  //     if (programRecords.data.length > 0) {
  //       const allRequiredDocsUploaded = documents?.every(
  //         (doc) =>
  //           doc?.required &&
  //           programRecords.data.find((record: any) => record?.id === doc?.id)
  //       );
  //       setEnableContinue(allRequiredDocsUploaded);
  //     }
  //   }, [programRecords]);

  //   useEffect(() => {
  //     if (programRecords?.data && programRecords?.data?.length > 0) {
  //         const uploadedRecords = programRecords?.data?.map(record => ({

  //         }))
  //   }, [programRecords]);

  useEffect(() => {
    if (documents) {
      const uploadedDocuments = documents?.map((document) => {
        const uploadedDocument = programRecords?.data?.filter(
          (programRecord) => programRecord?.title === document?.document_type,
        );
        return {
          ...document,
          uploadedDocument:
            uploadedDocument?.length && uploadedDocument?.length > 0
              ? uploadedDocument[0]
              : null,
        };
      });
      const allRequiredDocsUploaded = uploadedDocuments?.every((document) =>
        document?.required && document?.uploadedDocument
          ? true
          : !document?.required
            ? true
            : false,
      );
      //   setEnableContinue(allRequiredDocsUploaded);
      const config =
        supportPrograms[support_program_key as keyof typeof supportPrograms];
      const requiredDocuments = config?.documents?.required_documents.length;
      setEnableContinue(programRecords?.data?.length === requiredDocuments);
      setUploadedDocuments(uploadedDocuments);
    }
  }, [documents, programRecords]);

  const getProgramRecords = () => {
    const payload = {
      patient_id: patient?.data?.patient_id,
      report_type: documentType,
    };
    new Promise((resolve, reject) => {
      dispatch(actions.getProgramRecordsRequest({ resolve, reject, payload }));
    });
  };

  const handleContinue = () => {
    // Event: UPLOAD_DOCUMENTS_CONTINUE_CLICKED
    analytics.trackEvent(EVENT_NAMES.UPLOAD_DOCUMENTS_CONTINUE_CLICKED, {
      screen_name: SCREEN_NAMES.UPLOAD_DOCUMENTS_SCREEN,
      support_program_key: support_program_key,
    });
    onNext();
  };

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-4 flex-1 min-h-0 overflow-y-auto">
        <button
          className="flex items-center gap-1 px-4 py-2 -ml-4"
          onClick={onBack}
        >
          <ArrowLeft className="w-4 h-4 text-gray-500" />
          <p className="text-sm text-gray-500">Back</p>
        </button>

        <div className="my-4">
          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2">
            {title}
          </h1>
          <p className="text-[var(--text-secondary)]">{description}</p>
        </div>

        <div className="flex flex-col gap-4">
          {uploadedDocuments?.map((document) => (
            <ProgramDocumentCard
              key={document?.id}
              className="bg-white"
              documentData={document}
              documentType={documentType}
              document={document?.uploadedDocument}
              onSuccess={() => {
                // Event: RECORD_UPLOADED_SUCCESSFULLY
                analytics.trackEvent(EVENT_NAMES.RECORD_UPLOAD_SUCCESS, {
                  screen_name: SCREEN_NAMES.UPLOAD_DOCUMENTS_SCREEN,
                  support_program_key: support_program_key,
                  document_type: document?.document_type,
                });

                // Get Program Records
                getProgramRecords();
              }}
              onError={() => {
                // Event: RECORD_UPLOAD_ERROR
                analytics.trackEvent(EVENT_NAMES.RECORD_UPLOAD_ERROR, {
                  screen_name: SCREEN_NAMES.UPLOAD_DOCUMENTS_SCREEN,
                  support_program_key: support_program_key,
                  document_type: document?.document_type,
                });
              }}
            />
          ))}
        </div>
      </div>

      <div className="bg-white border-t border-gray-200 p-4 mt-auto">
        <Button
          fullWidth
          onClick={handleContinue}
          disabled={!enableContinue || updateProfile.isLoading}
          loading={updateProfile.isLoading}
          // className="mt-4"
        >
          <span className="flex items-center gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default UploadDocuments;
